/**
 * MyCopro - Syndic Layout
 * Layout principal pour l'espace Syndic avec navigation bottom
 */

import React from 'react';
import { Outlet } from 'react-router-dom';
import { SyndicBottomNav } from './SyndicBottomNav';

export const SyndicLayout: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-100 pb-20">
      {/* Contenu des pages */}
      <Outlet />

      {/* Navigation bottom */}
      <SyndicBottomNav />
    </div>
  );
};

export default SyndicLayout;
